<ion-row
  [formGroup]="securityScreeningForm"
  class="security-screening-form-container"
>
  <ion-col size="auto" class="select-width-225">
    <app-form-select
      [label]="CONST.SCREENING_TYPE"
      [options]="SCREENING_TYPE_OPTION"
      [placeholder]="CONST.SCREENING_TYPE"
      formControlName="screeningType"
      [required]="true"
      [hasAltHeight]="true"
    >
    </app-form-select>
  </ion-col>
  <ion-col size="auto" class="select-width-225">
    <app-form-select
      [label]="CONST.SCREENING_METHOD"
      [options]="
        securityScreeningForm.get('screeningType')?.value === '15'
          ? commodityVerificationOption
          : securityScreeningMethodsOption
      "
      [placeholder]="CONST.SCREENING_METHOD"
      formControlName="screeningMethod"
      [required]="true"
      [hasAltHeight]="true"
    >
    </app-form-select>

    <div
      class="checkbox-container"
      [class.checkbox-disabled-container]="
        securityScreeningForm.get('secondaryScreening')?.disabled
      "
    >
      <app-form-checkbox
        [label]="CONST.SECONDARY_SCREENING"
        formControlName="secondaryScreening"
        [required]="false"
      >
      </app-form-checkbox>
    </div>
  </ion-col>

  <ion-col size="auto">
    <app-form-input-field
      [label]="CONST.SCREENER_ID"
      [placeholder]="CONST.ENTER_ID"
      formControlName="screenerID"
      [required]="true"
      [maxLength]="25"
    ></app-form-input-field>
  </ion-col>
  <ion-col size="auto">
    <app-form-input-field
      [label]="CONST.TRACKING_NUMBER"
      [placeholder]="CONST.ENTER_TRACKING_NUMBER"
      formControlName="trackingNumber"
      [required]="true"
      (keypress)="
        commonUtils.preventSpecialCharacters(
          $event,
          SpecialCharacters.ALPHABET_NUMBER
        )
      "
      [maxLength]="18"
    ></app-form-input-field>
  </ion-col>
  <ion-col size="auto">
    <div class="form-group form-group-lg no-margin">
      <label class="big-label"
        >{{ CONST.SORT_DATE }} <span class="required-field">*</span>
      </label>
    </div>
    <app-form-date-picker
      [icon]="IMAGE.CALENDAR"
      [customClass]="'sort-date-picker'"
      formControlName="sortDate"
      [minDate]="minDate"
      [maxDate]="maxDate"
    ></app-form-date-picker>
  </ion-col>
  <ion-col size="auto" class="select-width-110">
    <app-form-select
      [label]="CONST.SORT_CODE"
      [options]="sortCodeOption"
      [placeholder]="CONST.SORT_CODE"
      formControlName="sortCode"
      [required]="true"
      [hasAltHeight]="true"
    >
    </app-form-select>
  </ion-col>
  <ion-col size="auto" class="submit-btn-col">
    <ion-button
      class="submit-btn ion-margin-bottom"
      [disabled]="securityScreeningForm.invalid"
      (click)="submit()"
    >
      {{ CONST.SUBMIT }}
    </ion-button>
  </ion-col>
</ion-row>
